/* ===========================================================
 * 
 *   Case Studies Filter Controller
 * 
 *   Custom functionality for the Case Study landing page
 * 
 *   Requires: jQuery
 * 
 * ===========================================================*/

$(function() {

    //  Keep track of the original page title
    var initialPageTitle = document.title;

    //  Start with an empty categories list
    var casestudiesCategories = [];

    /**
     * Process a category selection change
     */
    var applyCaseStudyFilter = function() {

        //  Empty the category list
        casestudiesCategories = [];

        //  Populate the category list
        $('.js__filter-casestudies').removeClass('active');
        $('.js__filter-casestudies input:checked').each( function(){
            casestudiesCategories.push( $(this).attr('data-selector') );
            $(this).parent().parent().addClass('active');
        });
        
        //  Are any categories selected?
        if(casestudiesCategories.length < 1 || casestudiesCategories == undefined){

            //  No - show all the items
            $('.card-impact').fadeIn();

            //  Reset the title
            document.title = initialPageTitle
            
            //  All done
            return;
        }

        //  Otherwise, start by hiding the items
        $('.card-impact').fadeOut();

        shownCount = 0;

        //  Then, show the selected items
        $(casestudiesCategories).each( function( idx, val ) {
            $('.' + val ).fadeIn();
            shownCount++;
        });

        if (shownCount <= 2) {
            $('.card-list-casestudies').addClass('list-count-small');
        } else {
            $('.card-list-casestudies').removeClass('list-count-small');
        }


    };

    
    /**
     * Init the listeners
     */
    $('.page-template-template-casestudies').each( function() {

        //  When a filter changes, reparse the items
        $(document).on('change', '.js__filter-casestudies input', applyCaseStudyFilter );

        //  Mobile filter toggle
        $(document).on('click', '.filter-title', function(){
            $(this).parent().toggleClass('filter-open');
        })
    });
});